import { render } from "./DonationCategoryManageListPage.vue?vue&type=template&id=2a8483c5&lang=true"
import script from "./DonationCategoryManageListPage.vue?vue&type=script&lang=js"
export * from "./DonationCategoryManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__